import { forwardRef, type TextareaHTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

/**
 * Textarea primitive — same look as `Input` but multiline.
 * Min height keeps it visually balanced with adjacent 40px inputs while still
 * allowing the user to drag-resize vertically.
 */
export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  error?: boolean;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, error = false, ...props }, ref) => {
    return (
      <textarea
        ref={ref}
        data-error={error || undefined}
        className={cn(
          'w-full min-h-[80px] px-3 py-2 text-sm bg-surface text-text rounded-md border outline-none transition-[border-color,box-shadow] duration-100 resize-y',
          'placeholder:text-text-4',
          !error && 'border-line-strong hover:border-text-3',
          !error && 'focus:border-volt-500 focus:ring-[3px] focus:ring-volt-glow',
          error && 'border-danger',
          error && 'focus:ring-[3px] focus:ring-[rgba(220,38,38,0.18)]',
          'disabled:opacity-50 disabled:cursor-not-allowed',
          className,
        )}
        {...props}
      />
    );
  },
);
Textarea.displayName = 'Textarea';
